import XLSX from 'xlsx-js-style' 
import { IDataTableTransferPlanning } from "@/resource/planning-cr/ModifyJsonData"
import { PdpaApi } from "@/api"
import { CustomDateFormat } from '@/utils/common'
import { config } from '@/config'
import dayjs from 'dayjs'

export const ExportExcel = (jsonData: IDataTableTransferPlanning[], headerPdpa: PdpaApi.IPdpaCollection[] , masterData: any, isColumnIBNonIB: boolean) => {
    console.log('ExportExcel', 'jsonData', jsonData)
    const { 
        masterContractStatus, 
        masterReceivePromotionData, 
        masterJoinEventData,
        masterPurposeOfBuyData,
        masterInspection1AppointmentStatusData,
        masterTransferStatus,
        masterTransferType,
        masterTransferPlanOperation,
        masterPayStatusType,
	    masterPayStatusCusOverPayType,
        crNameLists } = masterData
    const reportExcel = jsonData.map((x: any) => {
        let newJson = {} as any
        newJson[`ยูนิต`] = x.unitCode
        newJson[`สถานะขาย`] = x.saleStatus
        newJson[`บ้านเลขที่`] = x.addressNo
        newJson[`ชื่อลูกค้า`] = x.customerName
        newJson[`VIP`] = x.vipStatus

        if (headerPdpa.length > 0) {
            headerPdpa.forEach((p, index) => {
                if (p.id === config.pdpa.topic1) {
                    let fullNameTH = ""
                    const pdpa1 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId1}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic1, pdpa1, x.nationalityId, x.signProspectId1, x.fullNameTH1, x.fullNameEN1, "")
                    const pdpa2 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId2}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic1, pdpa1, x.nationalityId, x.signProspectId2, x.fullNameTH2, x.fullNameEN2, fullNameTH)
                    const pdpa3 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId3}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic1, pdpa3, x.nationalityId, x.signProspectId3, x.fullNameTH3, x.fullNameEN3, fullNameTH)
                    const pdpa4 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId4}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic1, pdpa4, x.nationalityId, x.signProspectId4, x.fullNameTH4, x.fullNameEN4, fullNameTH)
                    newJson[p.languages.filter(m => m.language == 'th')[0].name] = fullNameTH
				}
                if (p.id === config.pdpa.topic2) {
                    let fullNameTH = ""
                    const pdpa1 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId1}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic2, pdpa1, x.nationalityId, x.signProspectId1, x.fullNameTH1, x.fullNameEN1, "")
                    const pdpa2 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId2}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic2, pdpa1, x.nationalityId, x.signProspectId2, x.fullNameTH2, x.fullNameEN2, fullNameTH)
                    const pdpa3 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId3}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic2, pdpa3, x.nationalityId, x.signProspectId3, x.fullNameTH3, x.fullNameEN3, fullNameTH)
                    const pdpa4 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId4}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic2, pdpa4, x.nationalityId, x.signProspectId4, x.fullNameTH4, x.fullNameEN4, fullNameTH)
                    newJson[p.languages.filter(m => m.language == 'th')[0].name] = fullNameTH
				}

                if (p.id === config.pdpa.topic3) {
                    let fullNameTH = ""
                    const pdpa1 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId1}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic3, pdpa1, x.nationalityId, x.signProspectId1, x.fullNameTH1, x.fullNameEN1, "")
                    const pdpa2 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId2}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic3, pdpa1, x.nationalityId, x.signProspectId2, x.fullNameTH2, x.fullNameEN2, fullNameTH)
                    const pdpa3 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId3}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic3, pdpa3, x.nationalityId, x.signProspectId3, x.fullNameTH3, x.fullNameEN3, fullNameTH)
                    const pdpa4 = x.pdpa.filter((f: any) => f.identifier === `SF_${x.signProspectId4}`)
                    fullNameTH = pdpaConsent(config.pdpa.topic3, pdpa4, x.nationalityId, x.signProspectId4, x.fullNameTH4, x.fullNameEN4, fullNameTH)
                    newJson[p.languages.filter(m => m.language == 'th')[0].name] = fullNameTH
				}
			})
        }

        newJson[`Model`] = x.model
        newJson[`ราคาตามสัญญา`] = x.contractUnitPrice != "" ? parseInt(x.contractUnitPrice.replaceAll(",", "")) : ""
        newJson[`ราคาต่อ ตรม/ตรว`] = x.areaValue
        newJson[`ขนาดที่ดิน/พื้นที่ตามโฉนด`] = x.landArea
        newJson[`พื้นที่ใช้สอยตามโฉนด`] = x.usageArea
        newJson[`ขนาดที่ดิน/พื้นที่ตามสัญญา`] = x.landSize
        newJson[`พื้นที่ใช้สอยตามสัญญา`] = x.usageSize
        newJson[`ราคาขายสุทธิ`] = x.netPrice != "" ? parseFloat(x.netPrice.replaceAll(",", "")) : ""
        newJson[`เบอร์ติดต่อ`] = x.mobilePhone
        newJson[`สัญชาติ`] = x.country
        newJson[`Email`] = x.email
        newJson[`วันที่จอง`] = editDateForExcel(x.bookActivityDate)
        newJson[`วันที่ทำสัญญา`] = editDateForExcel(x.signActivityDate)
        newJson[`วันที่โอนตามสัญญา`] = editDateForExcel(x.contractTransferDate)
        newJson[`วันที่โอนตามจดหมายขอ ขยาย/ลด เวลา`] = editDateForExcel(x.letterRequestExtendReduceTransferDate)
        newJson[`งวดสุดท้าย`] = x.paymentLast
        newJson[`สถานะติดต่อ`] = masterContractStatus.filter((m: any) => m.id === x.contactStatusId).length > 0 ? masterContractStatus.filter((m: any) => m.id === x.contactStatusId)[0].descriptionTH : ""
        newJson[`รับโปร/ไม่รับโปร`] = masterReceivePromotionData.filter((m: any) => m.id === x.receivePromotionId).length > 0 ? masterReceivePromotionData.filter((m: any) => m.id === x.receivePromotionId)[0].descriptionTH : ""
        newJson[`เข้าร่วมงาน Event`] = masterJoinEventData.filter((m: any) => m.id === x.joinEventId).length > 0 ? masterJoinEventData.filter((m: any) => m.id === x.joinEventId)[0].descriptionTH : ""
        newJson[`วัตถุประสงค์ในการซื้อ`] = masterPurposeOfBuyData.filter((m: any) => m.id === x.purposeOfBuyId).length > 0 ? masterPurposeOfBuyData.filter((m: any) => m.id === x.purposeOfBuyId)[0].descriptionTH : ""
        newJson[`ลูกค้าต้องการฝาก Stock`] = x.customerDepositStock
        newJson[`สถานะการส่งมอบ`] = x.sendRoomStatus
        newJson[`คะแนน QC ครั้งล่าสุด`] = x.qcInspection
        newJson[`สถานะ QC ครั้งล่าสุด`] = x.qcStatus
        newJson[`วันที่ส่งห้อง 1`] = editDateForExcel(x.inspection1SendRoomDate)
        newJson[`สถานะการนัด/เข้าตรวจ 1`] = masterInspection1AppointmentStatusData.filter((m: any) => m.id === x.inspection1AppointmentStatusId).length > 0 ? masterInspection1AppointmentStatusData.filter((m: any) => m.id === x.inspection1AppointmentStatusId)[0].descriptionTH : ""
        newJson[`วันที่นัดลูกค้าตรวจ 1`] = editDateForExcel(CustomDateFormat(x.inspection1PlanCRDate, "DD/MM/YYYY"))
        newJson[`เวลาที่นัดลูกค้าตรวจ 1`] = x.inspection1PlanCRTime
        newJson[`ชื่อบริษัทรับตรวจบ้าน`] = x.inspectorName
        newJson[`สถานะห้องหลังตรวจ 1`] = x.inspection1TypeText
        newJson[`ครั้งที่ตรวจล่าสุด`] = x.inspectionNumLatest === 0 ? "" : x.inspectionNumLatest
        newJson[`วันที่ส่งห้องล่าสุด`] = editDateForExcel(x.inspectionSendRoomDateLatest)
        newJson[`สถานะการนัด/เข้าตรวจ ล่าสุด`] = masterInspection1AppointmentStatusData.filter((m: any) => m.id === x.inspectionAppointmentStatusLatest).length > 0 ? masterInspection1AppointmentStatusData.filter((m: any) => m.id === x.inspectionAppointmentStatusLatest)[0].descriptionTH : ""
        newJson[`วันที่นัดลูกค้าตรวจล่าสุด`] = editDateForExcel(CustomDateFormat(x.inspectionPlanCRDateLatest, "DD/MM/YYYY"))
        newJson[`เวลาที่นัดลูกค้าตรวจล่าสุด`] = x.inspectionPlanCRTimeLatest
        newJson[`CR Note`] = x.crComment
        newJson[`สถานะห้องหลังตรวจล่าสุด`] = x.inspectionTypeTextLatest
        newJson[`สรุปสถานะห้อง`] = x.summaryRoomStatus
        newJson[`CR Plan`] = editDateForExcel(CustomDateFormat(x.crPlan, "DD/MM/YYYY"))
        newJson[`วันที่นัดโอน`] = editDateForExcel(CustomDateFormat(x.transferPlanDate, "DD/MM/YYYY"))
        newJson[`วันที่ผิดนัดโอนกรรมสิทธิ์`] = editDateForExcel(CustomDateFormat(x.transferOutDateHistory, "DD/MM/YYYY"))
        newJson[`วันที่โอนจริง`] = editDateForExcel(CustomDateFormat(x.transferDateReal, "DD/MM/YYYY"))
        newJson[`Active Transfer`] = x.flagActiveTransfer
        newJson[`เดือนที่คาดว่าโอน`] = editExpectTranMonth(x.expectTranMonth)
        newJson[`สถานะการโอน`] = masterTransferStatus.filter((m: any) => m.id === x.transferStatusId).length > 0 ? masterTransferStatus.filter((m: any) => m.id === x.transferStatusId)[0].descriptionTH : ""
        newJson[`ประเภทการโอน`] = masterTransferType.filter((m: any) => m.id === x.transferTypeId).length > 0 ? masterTransferType.filter((m: any) => m.id === x.transferTypeId)[0].descriptionTH : ""
        newJson[`สถานะสินเชื่อ`] = x.bankCreditStatus
        newJson[`ธนาคารที่เลือกใช้`] = x.bankName
        newJson[`วงเงินอนุมัติของธนาคารที่เลือก`] = x.creditAppv === 0 ? "" : x.creditAppv
        newJson[`เหตุผลที่ใช้ธนาคาร`] = x.useBankReason
        newJson[`หมายเหตุ(อัพเดทระบบ Quotation, CS Report 18)`] = x.transferCRRemark
        newJson[`ชื่อหลังโฉนด 1`] = x.deedName1
        newJson[`ชื่อหลังโฉนด 2`] = x.deedName2
        newJson[`ชื่อหลังโฉนด 3`] = x.deedName3
        newJson[`ชื่อหลังโฉนด 4`] = x.deedName4
        newJson[`การดำเนินการ`] = masterTransferPlanOperation.filter((m: any) => m.id === x.operationId).length > 0 ? masterTransferPlanOperation.filter((m: any) => m.id === x.operationId)[0].descriptionTH : ""
        newJson[`เวลาการดำเนินการ`] = x.operationTime
        newJson[`ยอดปลอดจำนอง`] = x.mortgageValue != "" ? parseInt(x.mortgageValue.replaceAll(",", "")) : ""
        newJson[`ยอดปลอดจำนองส่วนต่างของบริษัท`] = x.mortgageCompValue != "" ? parseInt(x.mortgageCompValue.replaceAll(",", "")) : ""
        newJson[`หมายเหตุ(อัพเดทอีเมลแจ้งโอน)`] = x.lettTransRemark
        newJson[`วันที่นัดโอนหลังการโอนลอย`] = editDateForExcel(CustomDateFormat(x.transferPlanDateSp, "DD/MM/YYYY"))
        newJson[`ส่งอีเมลข้อมูลการโอน`] = x.flagTransferLetter
        newJson[`ส่งอีเมลผิดนัดการโอน`] = x.flagTransferOutLetter
        newJson[`ส่งอีเมลเปลี่ยนแปลงการโอน`] = x.flagTransferChangeLetter
        newJson[`ส่งอีเมลเลื่อนการโอน`] = x.flagTransferAdjustLetter
        newJson[`ส่งอีเมลยกเลิกการโอน`] = x.flagTransferCancelLetter
        newJson[`ส่งอีเมลยกเลิกผิดนัดการโอน`] = x.flagTransferOutCancelLetter
        newJson[`จดหมายตรวจ 1`] = x.inspectionLetter1//editDateForExcel(x.inspectionLetter1)
        newJson[`จดหมายตรวจ 2(รับมอบ)`] = x.inspectionLetter2//editDateForExcel(x.inspectionLetter2)
        newJson[`จดหมายรับมอบเข้า HC(HC)`] = x.receiveHCLetter
        newJson[`จดหมาย 1 (วันนัดโอน)`] = editDateForExcel(x.transferPlanDateLetter1)
        newJson[`ผิดนัด 1`] = editDateForExcel(x.transferOut1)
        newJson[`จดหมาย2 (วันนัดโอน)`] = x.transferPlanDateLetter2 //editDateForExcel(x.transferPlanDateLetter2)
        newJson[`ผิดนัด 2`] = editDateForExcel(x.transferOut2)
        newJson[`สถานะชำระ 100%`] = masterPayStatusType.filter((m: any) => m.id === x.payStatus100pc).length > 0 ? masterPayStatusType.filter((m: any) => m.id === x.payStatus100pc)[0].descriptionTH : "" 
        newJson[`สถานะชำระ 100% คืนเงิน(ลูกค้าชำระเกิน)`] = masterPayStatusCusOverPayType.filter((m: any) => m.id === x.payStatus100pcCusOverPay).length > 0 ? masterPayStatusCusOverPayType.filter((m: any) => m.id === x.payStatus100pcCusOverPay)[0].descriptionTH : "" 
        newJson[`หมายเหตุ สถานะ 100%`] = x.reasonStatus100pc
        newJson[`Unit Status`] = x.unitStatus
        newJson[`สรุป Plan โอน`] = editDateForExcel(x.finalPlanDate)
        newJson[`สรุปวันโอน(Plan+Actual)`] = editDateForExcel(x.finalActualDate)
        newJson[`Sales Name`] = x.salesName
        newJson[`CR Name`] = crNameLists.filter((m: any) => m.value == x.crId).length > 0 ? crNameLists.filter((m: any) => m.value == x.crId)[0].name : ""
        newJson[`Payment Method`] = x.paymentMethod
        newJson[`Agent Name`] = x.agentName 
        if (isColumnIBNonIB) {
            newJson[`IB/Non-IB`] = x.ibNonIb 
        }
        return newJson
    })
    console.log('reportExcel', reportExcel)
                        
    const dataWS = XLSX.utils.json_to_sheet(reportExcel, {dateNF: "dd/MM/yyyy" })
    const wb = XLSX.utils.book_new()

    const column = [
        { column: "A", width: 12  },
        { column: "B", width: 10  },
        { column: "C", width: 10  },
        { column: "D", width: 100 },
        { column: "E", width: 17  },
        { column: "F", width: 15  },
        { column: "G", width: 16  },
        { column: "H", width: 16  },
        { column: "I", width: 23  },
        { column: "J", width: 20  },
        { column: "K", width: 23  },
        { column: "L", width: 20  },
        { column: "M", width: 12  },
        { column: "N", width: 15  },
        { column: "O", width: 10  },
        { column: "P", width: 35  },
        { column: "Q", width: 15  },
        { column: "R", width: 15  },
        { column: "S", width: 18  },
        { column: "T", width: 34  },
        { column: "U", width: 11  },
        { column: "V", width: 11  },
        { column: "W", width: 11  },
        { column: "X", width: 11  },
        { column: "Y", width: 15  },
        { column: "Z", width: 20  },
        { column: "AA", width: 20  },
        { column: "AB", width: 15  },
        { column: "AC", width: 13  },
        { column: "AD", width: 13  },
        { column: "AE", width: 22  },
        { column: "AF", width: 20  },
        { column: "AG", width: 20  },
        { column: "AH", width: 20  },
        { column: "AI", width: 15  },
        { column: "AJ", width: 15  },
        { column: "AK", width: 30  },
        { column: "AL", width: 22  },
        { column: "AM", width: 22  },
        { column: "AN", width: 23  },
        { column: "AO", width: 15  },
        { column: "AP", width: 15  },
        { column: "AQ", width: 22  },
        { column: "AR", width: 12  },
        { column: "AS", width: 15  },
        { column: "AT", width: 16  },
        { column: "AU", width: 14  },
        { column: "AV", width: 15  },
        { column: "AW", width: 45  },
        { column: "AX", width: 45  },
        { column: "AY", width: 100 },
        { column: "AZ", width: 25  },
        { column: "BA", width: 100 },
        { column: "BB", width: 100 },
        { column: "BC", width: 50  },
        { column: "BD", width: 50  },
        { column: "BE", width: 50  },
        { column: "BF", width: 50  },
        { column: "BG", width: 35  },
        { column: "BH", width: 40  },
        { column: "BI", width: 26  },
        { column: "BJ", width: 100 },
        { column: "BK", width: 100 },
        { column: "BL", width: 23  },
        { column: "BM", width: 23  },
        { column: "BN", width: 23  },
        { column: "BO", width: 16  },
        { column: "BP", width: 22  },
        { column: "BQ", width: 20  },
        { column: "BR", width: 20  },
        { column: "BS", width: 16  },
        { column: "BT", width: 20  },
        { column: "BU", width: 15  },
        { column: "BV", width: 20  },
        { column: "BW", width: 35  },
        { column: "BX", width: 22  },
        { column: "BY", width: 31  },
        { column: "BZ", width: 15  },
        { column: "CA", width: 25  },
        { column: "CB", width: 35  },
        { column: "CC", width: 40  },
        { column: "CD", width: 40  },
        { column: "CE", width: 40  },
        { column: "CF", width: 40  },
        { column: "CG", width: 40  },
        { column: "CH", width: 40  },
        { column: "CI", width: 40  },
        { column: "CJ", width: 40  },
        { column: "CK", width: 40  },

    ]


    if (headerPdpa.length > 0 && !isColumnIBNonIB) {
        column.push({ column: "CK", width: 40 })
        column.push({ column: "CL", width: 40 })
        column.push({ column: "CM", width: 40 })
    }

    if (isColumnIBNonIB && headerPdpa.length == 0) {
        column.push({ column: "CK", width: 40 })
    }

    if (headerPdpa.length > 0 && isColumnIBNonIB) {
        column.push({ column: "CK", width: 40 })
        column.push({ column: "CL", width: 40 })
        column.push({ column: "CM", width: 40 })
        column.push({ column: "CN", width: 40 })

    }

    for (const key in column) {
        if (Object.prototype.hasOwnProperty.call(column, key)) {
            const c = column[key]
            dataWS[`${c.column}1`].s = {
                font: {
                    sz: 12,
                    bold: true,
                },
                fill: { 
                    patternType: "solid",
                    fgColor: { rgb: "FFE5E5E5" },
                },
                border: {
                    top: { style: "thin", color: { auto: 1 } },
                    right: { style: "thin", color: { auto: 1 } },
                    bottom: { style: "thin", color: { auto: 1 } },
                    left: { style: "thin", color: { auto: 1 } }
                }
            }

            
        }
    }

   

    let wscols: any = []
    for (const key in column) {
        if (Object.prototype.hasOwnProperty.call(column, key)) {
            const c = column[key]
            wscols.push({ wch: `${c.width}` })
        }
    }

    let nCols = 1
    for (const key in reportExcel) {
        nCols++

        if (headerPdpa.length == 0) {
            //วันที่จอง
            dataWS[`Q${nCols}`].t = "n"
            dataWS[`Q${nCols}`].z = "dd/MM/yyyy"
            //วันที่ทำสัญญา
            dataWS[`R${nCols}`].t = "n"
            dataWS[`R${nCols}`].z = "dd/MM/yyyy"
            //วันที่โอนตามสัญญา
            dataWS[`S${nCols}`].t = "n"
            dataWS[`S${nCols}`].z = "dd/MM/yyyy"
            //วันที่โอนตามจดหมายขอ ขยาย/ลด เวลา
            dataWS[`T${nCols}`].t = "n"
            dataWS[`T${nCols}`].z = "dd/MM/yyyy"
            //วันที่ส่งห้อง 1
            dataWS[`AD${nCols}`].t = "n"
            dataWS[`AD${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดลูกค้าตรวจ 1
            dataWS[`AF${nCols}`].t = "n"
            dataWS[`AF${nCols}`].z = "dd/MM/yyyy"
            //วันที่ส่งห้องล่าสุด
            dataWS[`AK${nCols}`].t = "n"
            dataWS[`AK${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดลูกค้าตรวจล่าสุด
            dataWS[`AM${nCols}`].t = "n"
            dataWS[`AM${nCols}`].z = "dd/MM/yyyy"
            //CR Plan
            dataWS[`AR${nCols}`].t = "n"
            dataWS[`AR${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดโอน
            dataWS[`AS${nCols}`].t = "n"
            dataWS[`AS${nCols}`].z = "dd/MM/yyyy"
            //วันที่ผิดนัดโอนกรรมสิทธิ์
            dataWS[`AT${nCols}`].t = "n"
            dataWS[`AT${nCols}`].z = "dd/MM/yyyy"
            //วันที่โอนจริง
            dataWS[`AU${nCols}`].t = "n"
            dataWS[`AU${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดโอนหลังการโอนลอย
            dataWS[`BM${nCols}`].t = "n"
            dataWS[`BM${nCols}`].z = "dd/MM/yyyy"
            //จดหมาย1 (วันนัดโอน)
            dataWS[`BW${nCols}`].t = "n"
            dataWS[`BW${nCols}`].z = "dd/MM/yyyy"
            //ผิดนัด 1
            dataWS[`BX${nCols}`].t = "n"
            dataWS[`BX${nCols}`].z = "dd/MM/yyyy"
            //ผิดนัด 2
            dataWS[`BZ${nCols}`].t = "n"
            dataWS[`BZ${nCols}`].z = "dd/MM/yyyy"
            // //สรุป Plan โอน
            dataWS[`CE${nCols}`].t = "n"
            dataWS[`CE${nCols}`].z = "dd/MM/yyyy"
            // //สรุปวันโอน(Plan+Actual)
            dataWS[`CF${nCols}`].t = "n"
            dataWS[`CF${nCols}`].z = "dd/MM/yyyy"
        } else {
            //วันที่จอง
            dataWS[`T${nCols}`].t = "n"
            dataWS[`T${nCols}`].z = "dd/MM/yyyy"
            //วันที่ทำสัญญา
            dataWS[`U${nCols}`].t = "n"
            dataWS[`U${nCols}`].z = "dd/MM/yyyy"
            //วันที่โอนตามสัญญา
            dataWS[`V${nCols}`].t = "n"
            dataWS[`V${nCols}`].z = "dd/MM/yyyy"
            //วันที่โอนตามจดหมายขอ ขยาย/ลด เวลา
            dataWS[`W${nCols}`].t = "n"
            dataWS[`W${nCols}`].z = "dd/MM/yyyy"
            //วันที่ส่งห้อง 1
            dataWS[`AG${nCols}`].t = "n"
            dataWS[`AG${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดลูกค้าตรวจ 1
            dataWS[`AI${nCols}`].t = "n"
            dataWS[`AI${nCols}`].z = "dd/MM/yyyy"
            //วันที่ส่งห้องล่าสุด
            dataWS[`AN${nCols}`].t = "n"
            dataWS[`AN${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดลูกค้าตรวจล่าสุด
            dataWS[`AP${nCols}`].t = "n"
            dataWS[`AP${nCols}`].z = "dd/MM/yyyy"
            //CR Plan
            dataWS[`AT${nCols}`].t = "n"
            dataWS[`AT${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดโอน
            dataWS[`AU${nCols}`].t = "n"
            dataWS[`AU${nCols}`].z = "dd/MM/yyyy"
            //วันที่ผิดนัดโอนกรรมสิทธิ์
            dataWS[`AT${nCols}`].t = "n"
            dataWS[`AT${nCols}`].z = "dd/MM/yyyy"
            //วันที่โอนจริง
            dataWS[`AW${nCols}`].t = "n"
            dataWS[`AW${nCols}`].z = "dd/MM/yyyy"
            //วันที่นัดโอนหลังการโอนลอย
            dataWS[`BO${nCols}`].t = "n"
            dataWS[`BO${nCols}`].z = "dd/MM/yyyy"
            //จดหมาย1 (วันนัดโอน)
            dataWS[`BY${nCols}`].t = "n"
            dataWS[`BY${nCols}`].z = "dd/MM/yyyy"
            //ผิดนัด 1
            dataWS[`BZ${nCols}`].t = "n"
            dataWS[`BZ${nCols}`].z = "dd/MM/yyyy"
            //ผิดนัด 2
            dataWS[`CB${nCols}`].t = "n"
            dataWS[`CB${nCols}`].z = "dd/MM/yyyy"
            // //สรุป Plan โอน
            dataWS[`CG${nCols}`].t = "n"
            dataWS[`CG${nCols}`].z = "dd/MM/yyyy"
            // //สรุปวันโอน(Plan+Actual)
            dataWS[`CH${nCols}`].t = "n"
            dataWS[`CH${nCols}`].z = "dd/MM/yyyy"

            dataWS[`F${nCols}`].s = { alignment: { wrapText: true } }
            dataWS[`G${nCols}`].s = { alignment: { wrapText: true } }
            dataWS[`H${nCols}`].s = { alignment: { wrapText: true } }
        }

        
    }

    dataWS['!cols'] = wscols
    XLSX.utils.book_append_sheet(wb, dataWS)
    XLSX.writeFile(wb,`TransferCR-${splitProjectCode(jsonData[0].unitCode)}${dayjs().format("DD-MM-YYYY")}.xlsx`)
}

const editExpectTranMonth = (value: string) => {
    const monthText: any = ['','Jan','Feb', 'Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    if (value != "") {
        const checkDate = value.split("-").length
        if (checkDate == 3) {
            const [year, month, day] = value.split("-")
            return `${monthText[parseInt(month)]}-${year}`
        } 
        if (checkDate == 2) {
            const [year, month] = value.split("-")
            return `${monthText[parseInt(month)]}-${year}`
        }
    }
    return value
}


const editDateForExcel = (date: string) => {
    if (date == "") return ""

    const checkDate = date.split("/").length
    if (checkDate < 3) return

    const [ day, month, year ] = date.split("/")
    const inDate =  new Date(`${month}/${day}/${year}`)
    const returnDateTime = 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
    return parseInt(returnDateTime.toString().substr(0,5));
}


const splitProjectCode = (data: string) => {
    if (data != "") {
        const [ project, unit ] = data.split("-")
        return `${project}`
    }
    return ""
}

const pdpaConsent = (topic: string, papa: any[], nationalityId: string, prospectId: string, fullNameTH: string, fullNameEN: string, joinName: string) => {
    let status = ""
    if (papa.length > 0) {
        status = "ยังไม่ได้"
        const purposes = papa[0].purposes.filter((f: any) => f.id === topic)
        if (purposes[0].status === 'ACTIVE') status = "ยินยอม"
        if (purposes[0].status === 'WITHDRAWN') status = "ไม่ยินยอม"
        if (purposes[0].status === 'NO_CONSENT') status = "ไม่ยินยอม"
    } else {
        if (prospectId != "0") status = "ยังไม่ได้"
    }
    if (prospectId == "0") return joinName
    if (joinName != "") return `${joinName}\n${nationalityId == '2' ? `${fullNameTH} - ${status}` : `${fullNameEN} - ${status}`}`
    return nationalityId == '2' ? `${fullNameTH} - ${status}` : `${fullNameEN} - ${status}`
}